module.exports = __webpack_public_path__ + "static/pic19-71f6098e4074732b24fab0b4cbfd145c.jpg";